function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(20262 -1963)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  transform: "translate(-20262 1963)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-20255.912 1970.604)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-3749.188,3451.062h-10.367a1.373,1.373,0,0,1-1.545-1.523q0-8.9,0-17.79a1.346,1.346,0,0,1,1.09-1.449,1.426,1.426,0,0,1,1.744.89,1.914,1.914,0,0,1,.064.571q0,7.858,0,15.717c0,.705,0,.705.689.705h18.7a1.423,1.423,0,0,1,1.425,1.992,1.349,1.349,0,0,1-1.355.886q-2.55,0-5.1,0Z",
  transform: "translate(3761.103 -3430.27)",
  fill: "currentColor",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-3648.553,3522.732c-1.2,0-2.4,0-3.607,0-.61,0-.782-.179-.784-.792,0-.456,0-.912,0-1.368,0-.484.221-.742.689-.743q3.752-.014,7.5,0a.6.6,0,0,1,.654.608c.022.579.025,1.16,0,1.739-.019.4-.252.556-.723.558C-3646.065,3522.734-3647.309,3522.732-3648.553,3522.732Z",
  transform: "translate(3661.917 -3512.393)",
  fill: "currentColor",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-3685.423,3466.461c.98,0,1.959,0,2.939,0,.574,0,.748.171.751.73,0,.483.006.966,0,1.449a.6.6,0,0,1-.656.681q-3.022.015-6.044,0c-.439,0-.654-.219-.67-.674-.02-.523-.015-1.049.008-1.572.02-.448.208-.613.652-.615C-3687.437,3466.458-3686.43,3466.461-3685.423,3466.461Z",
  transform: "translate(3695.088 -3463.458)",
  fill: "currentColor",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-3559.987,3574.263c.732,0,1.464-.014,2.2,0,.541.013.7.2.71.745.005.484.01.967,0,1.451-.01.447-.181.648-.627.652-1.547.016-3.094.011-4.641.006a.55.55,0,0,1-.6-.6c-.013-.538-.021-1.078,0-1.615.016-.449.192-.629.643-.639C-3561.534,3574.25-3560.76,3574.264-3559.987,3574.263Z",
  transform: "translate(3579.397 -3562.315)",
  fill: "currentColor",
  fillRule: "evenodd"
})));

function SvgIconLinesOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinesOverview);
export default __webpack_public_path__ + "static/media/icon-lines-overview.134dc114.svg";
export { ForwardRef as ReactComponent };